module.exports = __webpack_public_path__ + "static/media/028.aec5c6a7.jpg";